import React from 'react';
import styled from 'styled-components';

import {FixedSidebar} from '../../custom-feature/fixed-sidebar/FixedSidebar';
import {colorTheme} from '../../mixin/colorTheme';
import {Card} from '../card-v2/Card';
import {TabLoadingSpinner} from './TabLoadingSpinner';
import {TabBtnWrapper, TabOption} from './TabOption';
import {tabSize} from './tabSetup';

/**
 * @param {object} param0 Props.
 * @param {import('react').ReactNode} param0.children
 * @param {'sm'} [param0.size]
 * @param {import('react').ReactEventHandler<HTMLDivElement>} [param0.onSelect]
 * @returns {import('react').ReactElement & {
 * Option: typeof TabOption,
 * OptionWrapper: typeof TabBtnWrapper,
 * Wrapper: typeof TabsWrapper,
 * LoadingSpinner: typeof TabLoadingSpinner}}
 */
const Tab = ({children, onSelect, size, ...rest}) => (
    <TabsWrapper {...rest} size={size} onSelect={onSelect}>
        <Card>{children}</Card>
    </TabsWrapper>
);

const TabsWrapper = styled.div`
    ${colorTheme({
        '--in-sidebar-unselected-tab-text-color ': {
            dark: 'var(--label-text-color-100)     ',
            light: 'var(--gray-06)',
        },
        '--tab-option-border-active-color       ': {dark: 'var(--primary)     ', light: 'var(--primary)'},
        '--tab-option-background-active-color   ': {dark: 'var(--primary)      ', light: 'var(--primary)'},
        '--tab-option-text-active-color         ': {dark: 'var(--blue-04)      ', light: 'var(--blue-04)'},

        '--tab-option-border-active-hover-color       ': {
            dark: 'var(--blue-09)     ',
            light: 'var(--blue-09)',
        },
        '--tab-option-background-active-hover-color   ': {
            dark: 'var(--blue-09)      ',
            light: 'var(--blue-09)',
        },
        '--tab-option-text-hover-color   ': {dark: 'var(--blue-08)      ', light: 'var(--blue-08)'},
        '--tab-text-color-100   ': {dark: 'var(--gray-06)      ', light: 'var(--slate-08)'},
        '--tab-text-color-200   ': {dark: 'var(--slate-06)      ', light: 'var(--slate-07)'},
    })};

    --tab-container-border-color: var(--container-border-color-100);
    --unselected-tab-text-color: var(--tab-text-color-100);

    ${Card.Wrapper} &,
    ${FixedSidebar} & {
        --tab-container-border-color: var(--container-border-color-200);
        --unselected-tab-text-color: var(--tab-text-color-200);
        ${Card.Body} {
            justify-content: space-evenly;
            display: flex;
        }
    }
    ${Card.Wrapper} {
        box-shadow: unset !important;
        margin-bottom: var(--space-lg);
        width: fit-content;
    }
    ${Card.Body} {
        display: inline-flex;
        flex-wrap: wrap;
        gap: 2px;
        padding: 4px;
    }

    ${({size}) => tabSize(size)};
`;

Tab.Option = TabOption;
Tab.OptionWrapper = TabBtnWrapper;
Tab.Wrapper = TabsWrapper;
Tab.LoadingSpinner = TabLoadingSpinner;
export {Tab, TabsWrapper};
